import { Box, Tabs, Tab, Fade } from '@mui/material';
import {
    AceEnterMezzomediaMetrics
} from '../../../types/aceenter.types';
import AceEnterMezzomediaTable from './AceEnterMezzomediaTable';

import type { Dayjs } from 'dayjs';

type Props = {
  mezzomediaStats: AceEnterMezzomediaMetrics[];
  activeTab: number;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  selectedApp?: string | null;
  startDate: Dayjs;
  endDate: Dayjs;
};

export default function AceEnterDashboard({
  mezzomediaStats,
  activeTab,
  onTabChange,
  selectedApp,
  startDate,
  endDate
}: Props) {
  const fadeTimeout = { enter: 300, exit: 800 };  // ⏳ FadeIn 300ms, FadeOut 800ms (느리게)

  return (
    <Box>
      <Tabs value={activeTab} onChange={onTabChange} sx={{ mb: 2 }}>
        <Tab label="메조미디어" sx={{ fontWeight: 'bold' }} />
      </Tabs>

      <Fade in={activeTab === 0} timeout={fadeTimeout} unmountOnExit>
        <Box><AceEnterMezzomediaTable data={mezzomediaStats} selectedApp={selectedApp} startDate={startDate} endDate={endDate} /></Box>
      </Fade>
    </Box>
  );
}
